export default __webpack_public_path__ + "static/media/banSign.132f8146.svg";